<div class="container-fluid">
  <div>
    <div class="list-detail-top mt-2">
      <div>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="openNoteModal">
          {{ $t('message.button_vehicle_dtc_note_modal') }}
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" :disabled="!measuredId || processing" @click="csvExport">
          {{ $t('message.file_export') }}
        </b-button>
      </div>
      <div>
        <b-button :class="['ml-2 mt-2', checkButtonClassReGetDetail]" variant="primary" size="sm"
          @click="reGetCancelCodeResult">
          {{ $t('message.button_vehicle_dtc_gain_again') }}
        </b-button>
      </div>
    </div>
  </div>

  <cstm-table useStripeStyle useSort hasTabs rowSelect initSortDir="asc" :items="cancelCodeResultItems"
    :columns="cancelCodeResultColumns" class="mt-2 ml-2 cnc-cstm-table" type="simple" @rowButtonClicked="clickFFD"
    currentSortkey="status">
    <template v-slot:rowButton="{ row }">
      <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
      <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
    </template>
  </cstm-table>

  <div class="mt-3 mb-3">
    <table class="col-12">
      <tr>
        <td class="col-4"></td>
        <td class="col-4 text-center">
          <b-button variant="outline-primary" @click="closeResult">
            {{ $t("message.common_button_back") }}
          </b-button>
        </td>
        <td class="col-4 text-right pr-0">
          <b-form-select v-if="isEyesight(systemId) && functionList.length > 0" class="custom-select custom-select-sm"
            v-model="systemES.selectedId" @change="changeCancelCodeES" :disabled="!systemES.isActiveDropdown">
            <option v-for="selectedItem in systemES.pullDownList" :value="selectedItem.cancel_code_id">
              {{ selectedItem.menu_title }}
            </option>
          </b-form-select>
          <b-form-select v-if="isAdasEcu(systemId) && functionList.length > 0" class="custom-select custom-select-sm"
            v-model="systemADAS.selectedId" @change="changeCancelCodeADAS" :disabled="!systemADAS.isActiveDropdown">
            <option v-for="selectedItem in systemADAS.pullDownList" :value="selectedItem.cancel_code_id">
              {{ selectedItem.menu_title }}
            </option>
          </b-form-select>
        </td>
      </tr>
    </table>
  </div>

  <!-- FFD 一覧画面 -->
  <b-modal v-model="modalFfd" size="huge" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100 modal-title" :title="modalTitle">{{ modalTitle }}</div>
    </template>

    <ffd-modal v-if="modalFfd" :ffdTableProp="ffdTableItems" :systemProp="selectedCancelCode" :ffdSystem="ffdSystem"
      :ffdDescription="ffdDescription" :systemID="systemId" destinationAPI="cnc" :projectId="projectId"
      :measureId="measuredId" @updateLoading="processing = $event" ref="ffd_modal">
      <template v-slot:didTestBtn>
        <b-button v-if="testModeVisible" class="clear-button" variant="primary" size="sm" @click="didTestDataExport">
          Export DID Data
        </b-button>
      </template>
    </ffd-modal>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" @click="closeFfdModal" class="ml-2 mr-2">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- メモ画面 -->
  <b-modal v-model="modalMemo" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_note_modal') }}
      </div>
    </template>

    <memo-page v-if="modalMemo" ref="memo" :projectId="projectId" :measureId="measuredId" destinationAPI="cnc"
      functionNameKey="individual.individual_diagnosis_function_cancel_code"  @closeNoteModal="closeNoteModal"
      :modalLoading="isMemoDialogLoading" @update-loading="isMemoDialogLoading = $event" />

    <template v-slot:footer>
      <button type="button" :disabled="isMemoDialogLoading" v-on:click="memoClear()"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">{{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="outline-primary" @click="closeNoteModal" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="primary" @click="memoSave" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- CRUISE SW確認画面 -->
  <b-modal v-model="modalCruise" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>

    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.common_title_confirmation') }}
      </div>
    </template>

    <div class="container-fluid">
      <div class="row no-gutters">
        <div class="col-12" style="white-space: break-spaces;"
          v-html="$t(`individual.message_vehicle_cnc_cruise_sw_get_information`)"></div>
      </div>
    </div>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" @click="closeCruiseModal" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="cruiseSwExecute" class="ml-2 mr-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>

    <processing-view-cruiseSW :processing="processingCruiseSW"></processing-view-cruiseSW>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>